import React, { PropsWithChildren } from 'react';
import { Flex } from 'antd';

export const StepList = ({ children }: PropsWithChildren) => {
    return <Flex vertical>{children}</Flex>;
};
